
export default (...args) => Object.assign({}, ...args);
